import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import Typography from '@mui/material/Typography';

import AcaoMenu from "../../Components/AcaoMenu";
import { ApplicationState } from "../../store";

import * as CursoActions from '../../store/ducks/curso/actions'
import CursoTableComponent from "../../Components/TableCurso";
import ModalCadastroCurso from "../../Components/ModalCadastroCurso";
import Loading from "../../Components/LoadingComponent";
import AlertaConfirmaAcao from "../../Components/AlertaConfirmaAcao";
import { EntidadesAcoes } from "../../config/enums/EntidadesAcoesConfirmacao";

const _body = {
    pagina: 0,
    tamanho: 10,
    ordem: "ASC",
    coluna: "nmCurso",
    txtBusca: ""
};

function Curso({
    curso,
    utils,
    getCursoTable,
    onInativarCurso,
    getCursoData,
    onSaveCurso,
    onUpdateCurso,
    onNotificacaoCurso,
    clearCursoData
}: any) {

    const [idsSelecionado, setIdSelecionado] = useState<number[]>([]);
    const [modalCadastroOpen, setModalCadastroOpen] = useState(false);
    const [body, setBody] = useState(_body);
    const [table, setTable] = useState(null);
    const [alertConfirmacaoOpen, setAlertConfirmacaoOpen] = useState(false);
    const [alertConfirmacaoTexto, setAlertConfirmacaoTexto] = useState('');
    const [alertConfirmacaoAcao, setAlertConfirmacaoAcao] = useState(() => () => {});

    useEffect(() => {
        if(curso.error){
            alert('Erro!\nAtenção, ocorreu um erro durante sua solicitação. Caso apareça essa mensagem novamente procure o Suporte:\nDescrição do erro: ' + curso.errorMessage);
        }
    }, [curso.error]);

    useEffect(() => {
        if(!curso.loadingPersis) {
            handleCloseAndReload()
        }
    }, [curso.loadingPersis]);

    useEffect(() => {
        if(!modalCadastroOpen) {
            getCursoTableData();
        }
    }, [body, modalCadastroOpen]);

    useEffect(() => {
        if(curso.data.table != null){
            setTable(curso.data.table);
        }

    }, [curso.data]);

    useEffect(() => {
        if(!curso.loadingInativacao){
            getCursoTable(body);
        }
    }, [curso.loadingInativacao]);

    const getCursoTableData = () => {
        getCursoTable(body);
    }

    const handleCadastro = () => {
        clearCursoData();
        setModalCadastroOpen(true)
    }

    const handleEdicao = () => {
        if(idsSelecionado.length == 0) {
            alert('Selecione um curso que gostaria de alterar');

        } else if(idsSelecionado.length > 1) {
            alert('Selecione apenas um curso para alteração!');

        } else {
            getCursoData(idsSelecionado[0]);
            setModalCadastroOpen(true);
        }
    }

    const handleInativacao = () => {
        if(idsSelecionado.length == 0) {
            alert('Selecione os cursos que gostaria de excluir');
        } else {
            setAlertConfirmacaoOpen(true);
            setAlertConfirmacaoTexto(EntidadesAcoes.CURSO_EXCLUSAO);
            setAlertConfirmacaoAcao(() => () => {
                onInativarCurso(idsSelecionado);
                setAlertConfirmacaoOpen(false);
            })
        }
    }

    const changeTable = (__body: any) => {
        setBody({...__body});
    }

    const handlePersistCurso = (edicao: boolean, curso: FormData) => {
        if(edicao) {
            setIdSelecionado([]);
            onUpdateCurso(curso);
        } else {
            onSaveCurso(curso);
        }

    }

    const handleCloseAndReload = () => {
        clearCursoData();
        setModalCadastroOpen(false);
        setIdSelecionado([]);
    }

    const unmountAlertConfirmacao = () => {
        setAlertConfirmacaoTexto('');
        setAlertConfirmacaoAcao(() => () => {})
        setAlertConfirmacaoOpen(false);
    }

    return (
        <div className="pageBox">
            <Loading loading={curso.loading || curso.loadingPersis} />
            <AlertaConfirmaAcao openDialog={alertConfirmacaoOpen} texto={alertConfirmacaoTexto} execAcao={() => alertConfirmacaoAcao()} cancelaAcao={() => unmountAlertConfirmacao()} />
            <ModalCadastroCurso 
                modalCadastroOpen={modalCadastroOpen} 
                closeModal={() => handleCloseAndReload()}
                cursoData={curso.data.curso}
                id={idsSelecionado[0]} 
                persist={handlePersistCurso}
                enviaNotificacao={(idCurso: any) =>  onNotificacaoCurso(idCurso)}
            />
            <div className="menuLateral">
                <Typography variant="h6" noWrap component="div" sx={{
                    width: '100%'
                }} >
                    Ações
                    <AcaoMenu
                        onCadastro={handleCadastro} 
                        onEditar={handleEdicao} 
                        onInativar={handleInativacao} 
                    />
                </Typography>
            </div>
            <div className="table">
                <CursoTableComponent
                    loading={curso.loadingTable} 
                    data={table} 
                    body={body}
                    onChange={changeTable} 
                    selection={idsSelecionado}
                    idSelectionChange={(idsArr: number[]) => setIdSelecionado(idsArr)}/>
            </div>
        </div>
    )
};

const mapStateToProps = (state: ApplicationState) => ({
    curso: state.curso,
    utils: state.utils
});
  
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({...CursoActions}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Curso);
